import React from 'react';
import { Typography, TextField } from '@mui/material';
import Div from '@jumbo/shared/Div';
import Autocomplete from '@mui/material/Autocomplete';

const DropdownInput = ({
  inputLabel,
  sx,
  onChange,
  onBlur,
  value,
  data,
  name,
  noTitle,
  placeholder,
  required = false,
  defaultValue,
  onClickCapture,
  labeling = {
    id: 'id',
    name: 'name',
  },
}) => {
  // Check if data is null or undefined
  const hasData = data && Array.isArray(data);

  return (
    <Div sx={{ position: 'relative', width: '100%', ...sx }}>
      {!noTitle && (
        <Typography variant={'body1'} fontWeight={500} mb={1} fontSize={16}>
          {inputLabel}{required && <span style={{ fontWeight: 'bold', fontSize: 14, color: 'red' }}> *</span>}
        </Typography>
      )}
      <Div sx={{ position: 'relative' }}>
        <Autocomplete
          value={value}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          onAbortCapture={onClickCapture}
          options={hasData ? data : []}
          getOptionLabel={(option) => (hasData && option ? option[labeling.name] : "Data tidak ditemukan")}
          noOptionsText="Data tidak ditemukan"
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder={defaultValue}
              fullWidth
              InputProps={{
                ...params.InputProps,
                style: { backgroundColor: 'white', borderRadius: 8, borderColor: '#ADADAD' }
              }}
            />
          )}
        />
      </Div>
    </Div>
  );
};

export default DropdownInput;
